const { trackGtm, trackDownload, trackGtm4 } = require('util/functions');

module.exports = {
	init() {
		this.title = this.root.querySelector('.content-button--title');
		this.btn = this.root.querySelector('.content-button--cta');
		this.titles = this.root.querySelectorAll('h1, h2, h3, h4, h5, h6');
		this.download = this.root.dataset.download;
		this.initEvents();
	},
	initEvents() {
		this.btn.addEventListener('click', () => {
			this.gtmTracking();
		});
	},
	gtmTracking() {
		let titleValue;

		this.titles.forEach(element => {
			if (element.innerText) {
				titleValue = element.innerText;
			}
		});

		if (!titleValue) {
			titleValue = 'Title is not set';
		}

		const titleText = titleValue;
		const { innerText, href } = this.btn;

		trackGtm4({
			event: 'GA4_event_c_cta',
			widget_name: 'V3-Content-button',
			widget_title: titleText,
			link_text: innerText,
			link_url: href,
			button_type: '',
		});

		if (this.download === 'true') {
			trackDownload(titleText, href);
		} else {
			trackGtm({
				event: 'GA Tracking',
				eventCategory: 'cta',
				eventAction: 'content-button',
				eventLabel: `${titleText} | ${innerText} | ${href}`,
			});
		}
	},
};
